export const getFiltersParams = (activeFilters) => {
  if (!activeFilters.length) {
    return '';
  } else {
    const paramsArray = activeFilters.map(filter => `${filter.queryValue}=${filter.value}`);
    return paramsArray.join('&') + '&';
  }
}

export const clearIdentityBlock = (dispatch, clearCraftBlock, block, queryParams, setQueryParams, setMatches, refreshMatches, firstSelectedCard, setIsMatchesLoading) => {
  dispatch(clearCraftBlock({ type: 'identity', block }));

  switch (block.placeholder) {
    case 'Category':
      queryParams.delete('category');
      break;
    case 'Month':
      queryParams.delete('month');
      break;
    case 'Day':
      queryParams.delete('day');
      break;
    case 'Year':
      queryParams.delete('year');
      break;
    default:
      break;
  }

  const updatedQueryParams = new URLSearchParams(queryParams);

  setQueryParams(updatedQueryParams);

  if (updatedQueryParams.toString() === '') {
    setMatches([]);
  } else {
    refreshMatches(updatedQueryParams, setMatches, setIsMatchesLoading, firstSelectedCard);
  }
};

export const clearIdentityBlocks = (dispatch, clearCraftBlocks, setActiveBlock, setMatches, setQueryParams) => {
  dispatch(clearCraftBlocks('identity'))
  setActiveBlock('Category');
  setMatches([]);
  setQueryParams(new URLSearchParams());
}

export const getFilteredMatches = (matches, searchMatchesInput, sortType) => {

  if (!matches) {
    return [];
  }

  let filteredMatches = matches;

  if (searchMatchesInput) {
    const lowerCaseSearchInput = searchMatchesInput.toLowerCase();
    filteredMatches = matches.filter((item) => {
      return (
        item.name.toLowerCase().includes(lowerCaseSearchInput) ||
        (item.custom_one && item.custom_one.toLowerCase().includes(lowerCaseSearchInput)) ||
        (item.custom_two && item.custom_two.toLowerCase().includes(lowerCaseSearchInput))
      );
    });
  }


  if (sortType === "Ready to Craft") {
    return filteredMatches.sort((a, b) => {
      const countNotOwnedA = [
        a.birth_day.status,
        a.birth_month.status,
        a.birth_year.status,
        a.category.status,
      ].filter((status) => status === "Not Owned").length;

      const countNotOwnedB = [
        b.birth_day.status,
        b.birth_month.status,
        b.birth_year.status,
        b.category.status,
      ].filter((status) => status === "Not Owned").length;

      return countNotOwnedA - countNotOwnedB;
    });
  } else if (sortType === "A-Z") {
    return filteredMatches.sort((a, b) => {
      const lastNameA = a.name.split(" ").length > 1 ? a.name.split(" ")[1] : a.name;
      const lastNameB = b.name.split(" ").length > 1 ? b.name.split(" ")[1] : b.name;
      return lastNameA.localeCompare(lastNameB);
    });
  } else if (sortType === "Z-A") {
    return filteredMatches.sort((a, b) => {
      const lastNameA = a.name.split(" ").length > 1 ? a.name.split(" ")[1] : a.name;
      const lastNameB = b.name.split(" ").length > 1 ? b.name.split(" ")[1] : b.name;
      return lastNameB.localeCompare(lastNameA);
    });
  }

  return filteredMatches;
};


export const nextIdentityStep = (activeBlock, setActiveBlock) => {
  switch (activeBlock) {
    case 'Category':
      setActiveBlock('Month');
      break;
    case 'Month':
      setActiveBlock('Day');
      break;
    case 'Day':
      setActiveBlock('Year');
      break;
    default:
      break;
  }
}

export const clearPredictionBlock = (dispatch, clearCraftBlock, block, setEligibles) => {
  dispatch(clearCraftBlock({ type: 'prediction', block }));
  setEligibles([])
}

export const clearPredictionBlocks = (dispatch, clearCraftBlocks, setActiveBlock, setEligibles, setQueryParams) => {
  dispatch(clearCraftBlocks('prediction'))
  setActiveBlock('Event');
  setEligibles([]);
  setQueryParams(new URLSearchParams());
}

export const nextPredictionStep = (activeBlock, craftBlocks, setActiveBlock) => {
  switch (activeBlock) {
    case 'Identity':
      if(!craftBlocks[1].value) {
        setActiveBlock('Event');
      } else {
        setActiveBlock('Trigger');
      }
      break;
    case 'Event':
      if (!craftBlocks[0].value) {
        setActiveBlock('Identity');
      } else {
        setActiveBlock('Trigger');
      }
      break;
    case 'Trigger':
      setActiveBlock('Prize');
      break;
    default:
      break;
  }
}
